import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrClosing } from '../../../../../../../shared/types/modules/pqr';

export const usePqrCompensation = (closing?: PqrClosing) => {
    const formik = useFormik({
        initialValues: {
            compensation: false,
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            compensation: closing?.compensation || false,
        });
    }, [closing]);

    return {
        formik,
    };
};
